import React from 'react'

type Props = {
  title?: string
  message: string
  shadowColor?: string
}

export function WooNotesInfoAlert({ title = 'Something occured', message, shadowColor }: Props) {
  if (!message) return null

  return (
    <div
      style={{
        padding: '14px 16px',
        borderRadius: 16,

        border: '2px solid #3E6E8C',

        background: 'linear-gradient(180deg, #D7F0FF 0%, #A9D9F5 55%, #78B9E6 100%)',

        color: '#123246',

        boxShadow: `
    0 6px 0 #2E5B77,
    0 12px 22px rgba(18,50,70,0.22)
  `,

        display: 'flex',
        gap: 12,
        alignItems: 'flex-start',

        animation: 'wooShake 300ms ease',
      }}
    >
      {/* Icon */}
      <div style={{ fontSize: 22, lineHeight: '22px' }}>⚠️</div>

      <div style={{ display: 'grid', gap: 4 }}>
        {!!title && <div style={{ fontWeight: 900 }}>{title}</div>}
        <div style={{ fontWeight: 700 }}>{message}</div>
      </div>

      <style>{`
        @keyframes wooShake {
          0% { transform: translateX(0); }
          25% { transform: translateX(-4px); }
          50% { transform: translateX(4px); }
          75% { transform: translateX(-2px); }
          100% { transform: translateX(0); }
        }
      `}</style>
    </div>
  )
}
